jQuery(function($){
  $(document).ready(function(){
    //console.log('test');
    var i = 1; 
    var collection = $(".dynamic-heading");
    
    $("#js-rotating").Morphext({
        // The [in] animation type. Refer to Animate.css for a list of available animations.
        animation: "fadeIn",
        // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
        separator: ",",
        // The delay between the changing of each phrase in milliseconds.
        speed: 3000,
        complete: function () {
            // Called after the entrance animation is executed.
        }
    });

    /*$(".dynamic-heading").click(function() {    
      $(collection).css('display', 'none');
      $(collection[i]).show();
      i++
      i = i % collection.length;
    }); */

    $(document).on('click', ".desktop-top-bar-search", function(e){
      e.preventDefault();
      console.log("searched");
        var formType = $(this).closest('form').find('[name="type"]').val();
      //console.log(formType);
        var position = $(document).scrollTop();
      //console.log(position);
      //console.log($(".mobile-search"));
        window.searchAutocomplete.showDesktopTopBarSearch(formType, position);
    });
  
    //window.Cookies.set('promo-banner', 'has', { expires: 30, path: '', domain: '', sameSite: 'None', secure: true, });
  
//     console.log($('header#header-main-nav').height());
//     if( $('#header-main-nav').hasClass('sticky_nav') && $('#header-main-nav').hasClass('sticky_nav--stick') ){
//       $( "section:first" ).css( "margin-top", $('header#header-main-nav').height()+'px' );
//     }
    $( "#privy-container" ).css( "display", 'none !important' );
    
    $(".featured-promotions-mobile-only").flickity({
      wrapAround: true,
      //cellAlign: 'left',
      //imagesLoaded: true,
      prevNextButtons: true,
      draggable: true,
      pageDots: false,
      autoPlay: false,
      //contain: true,
      //groupCells: true
    });
    
    function forMobileDevices(x) {
      if (x.matches) { // If media query matches
//         $( "section:first" ).css( "margin-top", $('header#header').height()+'px' );
      } 
    }

    var x = window.matchMedia("(max-width: 767px)");
    forMobileDevices(x); // Call listener function at run time
    x.addListener(forMobileDevices); // Attach listener function on state changes
    
    if($('body.product').find('[name=add_free_gift_wrap]')){
      $('input[name=add_free_gift_wrap]').on('click', function(){
        if($('input[name=add_free_gift_wrap]').is(':checked')){
          //console.log('free_gift_wrap');
          var selected_variant_id = $('body.product').find('.selected_variant').val();
          var selected_variant_title = $('body.product').find('.product_name').text();
          $('form.shopify-product-form').append('<input type="hidden" class="free_gift_wrap" name="id[]" value="37539127099584" /><input type="hidden" class="free_gift_wrap_for" name="properties[_free_gift_wrap_for_variant]" value="'+selected_variant_id+','+selected_variant_title+'" />');
        } else{
          $('body.product').find('form.shopify-product-form').find('.free_gift_wrap').remove();
          $('body.product').find('form.shopify-product-form').find('.free_gift_wrap_for').remove();
        }
      })
    }
    
//     $.ajax({
//             url: '/cart.js',
//             dataType: 'json',
//             cache: false,
//             success(cart) {
        
//         console.log(cart);
        
              
//             },
//           });
    
    
    //console.log($('[data-cart-quantity-input]').parents('[data-cart-item]').data('cart-item-props'));
    
  });
});


